import * as Yup from 'yup';
import { REQUIRED_ERROR_MSG } from 'utils/constants/errors';

export const mealSchema = mealsName => {
  return Yup.object().shape({
    name: Yup.string()
      .notOneOf(mealsName)
      .required(REQUIRED_ERROR_MSG)
      .max(500),
    tip: Yup.string().max(500)
  });
};

export const addIngredientSchema = Yup.object().shape({
  servingSize: Yup.number()
    .positive()
    .required(REQUIRED_ERROR_MSG),
  measurementUnit: Yup.string()
    .required(REQUIRED_ERROR_MSG)
});

export const createFoodSchema = Yup.object().shape({
  name: Yup.string()
    .required(REQUIRED_ERROR_MSG)
    .max(500),
  fat: Yup.number()
    .min(0)
    .required(REQUIRED_ERROR_MSG),
  protein: Yup.number()
    .min(0)
    .required(REQUIRED_ERROR_MSG),
  carbs: Yup.number()
    .min(0)
    .required(REQUIRED_ERROR_MSG),
  calories: Yup.number()
    .min(0)
    .required(REQUIRED_ERROR_MSG),
  weight_grams: Yup.number()
    .min(0)
    .required(REQUIRED_ERROR_MSG),
  quantity_size: Yup.number()
    .positive()
    .required(REQUIRED_ERROR_MSG)
});
